"use strict";

const FAIXAS_PADRAO = [
  { qty: 3, pct: 20 },
  { qty: 4, pct: 25 },
  { qty: 5, pct: 30 },
  { qty: 7, pct: 40 },
];

function normalizarFaixas(lista) {
  return lista
    .map((f) => ({
      qty: Number(f.qty) || 1,
      max: Number(f.max) || 0,
      pct: Number(f.pct) || 0,
    }))
    .sort((a, b) => a.qty - b.qty);
}

function lerConfig() {
  const vazio = {
    faixas: FAIXAS_PADRAO,
    limitarRegua: false,
    porRange: false,
    cupom: "",
    limites: { descontoMaximo: 0, tetoCarrinho: 0 },
  };
  const el = document.getElementById("pd-faixas-json");
  if (!el) return vazio;
  try {
    const parsed = JSON.parse(el.textContent);
    if (Array.isArray(parsed) && parsed.length) {
      return { ...vazio, faixas: normalizarFaixas(parsed) };
    }
    if (parsed && Array.isArray(parsed.faixas) && parsed.faixas.length) {
      return {
        faixas: normalizarFaixas(parsed.faixas),
        limitarRegua: Boolean(parsed.limitarRegua),
        porRange: Boolean(parsed.porRange),
        cupom: String(parsed.cupom || "").trim(),
        limites: {
          descontoMaximo: Number(parsed.limites?.descontoMaximo) || 0,
          tetoCarrinho: Number(parsed.limites?.tetoCarrinho) || 0,
        },
      };
    }
  } catch (e) {
    console.error("Faixas de desconto inválidas", e);
  }
  return vazio;
}

function formatarDinheiro(centavos) {
  const valor = (Number(centavos) / 100).toFixed(2).replace(".", ",");
  return `R$ ${valor}`;
}

function labelItens(n) {
  return Number(n) === 1 ? "produto" : "produtos";
}

function fraseFaltam(n) {
  const qtd = Number(n);
  if (qtd === 1) return "Falta 1 produto";
  return `Faltam ${qtd} produtos`;
}

function htmlPreco(bruto, atual) {
  if (atual < bruto) {
    return `<s class="pd-preco--antigo">${formatarDinheiro(bruto)}</s> <span class="pd-preco--atual">${formatarDinheiro(atual)}</span>`;
  }
  return `<span class="pd-preco--atual">${formatarDinheiro(bruto)}</span>`;
}

function descontoPorUnidade(centavos, pct) {
  return Math.floor((Number(centavos) * Number(pct)) / 100);
}

function totaisPedido(cart, pct, limites) {
  const bruto = Number(cart.original_total_price || cart.total_price || 0);
  const shopifyAtual = Number(cart.total_price || 0);
  if (pct > 0) {
    const teto = Number(limites?.tetoCarrinho) || 0;
    const items = cart.items;
    if (!teto && Array.isArray(items) && items.length) {
      return aplicarLimitesItens(items, pct, limites, bruto);
    }
    return aplicarLimites(bruto, pct, limites);
  }
  if (shopifyAtual < bruto) {
    return { bruto, atual: shopifyAtual, desconto: bruto - shopifyAtual, limitado: false };
  }
  return { bruto, atual: bruto, desconto: 0, limitado: false };
}

function aplicarLimites(bruto, pct, limites) {
  const teto = Number(limites?.tetoCarrinho) || 0;
  const maxDesc = Number(limites?.descontoMaximo) || 0;
  const base = teto > 0 ? Math.min(bruto, teto) : bruto;
  let desconto = Math.round(base * (pct / 100));
  const descontoSemTeto = Math.round(bruto * (pct / 100));
  if (maxDesc > 0) desconto = Math.min(desconto, maxDesc);
  return {
    bruto,
    atual: Math.max(0, bruto - desconto),
    desconto,
    limitado: desconto < descontoSemTeto,
  };
}

function aplicarLimitesItens(items, pct, limites, brutoFallback) {
  let bruto = 0;
  let desconto = 0;
  items.forEach((item) => {
    const lineBruto = Number(item.original_line_price || item.line_price || 0);
    const qty = Number(item.quantity) || 0;
    if (qty <= 0) return;
    const unit = Math.round(lineBruto / qty);
    bruto += lineBruto;
    desconto += descontoPorUnidade(unit, pct) * qty;
  });
  if (!bruto) bruto = Number(brutoFallback) || 0;
  const maxDesc = Number(limites?.descontoMaximo) || 0;
  const descontoCheio = desconto;
  if (maxDesc > 0) desconto = Math.min(desconto, maxDesc);
  return {
    bruto,
    atual: Math.max(0, bruto - desconto),
    desconto,
    limitado: desconto < descontoCheio,
  };
}

function totaisItem(item, totais, pct) {
  const bruto = Number(item.original_line_price || item.line_price || 0);
  if (!totais || !totais.bruto || totais.desconto <= 0) return { bruto, atual: bruto };
  if (!totais.limitado && pct > 0) {
    const qty = Number(item.quantity) || 1;
    const unit = Math.round(bruto / qty);
    return { bruto, atual: (unit - descontoPorUnidade(unit, pct)) * qty };
  }
  const atual = Math.round(bruto * (totais.atual / totais.bruto));
  return { bruto, atual };
}

function montarRanges(faixas, porRange, limitarRegua) {
  return faixas.map((faixa, i) => {
    const isFirst = i === 0;
    const isLast = i === faixas.length - 1;
    const start = isFirst && porRange ? 1 : faixa.qty;
    let end;
    if (faixa.max > 0) {
      end = Math.max(faixa.max, start);
    } else if (isLast) {
      end = limitarRegua ? faixa.qty : Infinity;
    } else {
      end = faixas[i + 1].qty - 1;
    }
    if (isLast && !limitarRegua) end = Infinity;
    return { start, end, pct: faixa.pct, qty: faixa.qty };
  });
}

function calcularProgresso(itemCount, faixas, limitarRegua, porRange) {
  const total = Number(itemCount) || 0;
  const n = faixas.length;
  if (!n) {
    return {
      fill: 0,
      currentPct: 0,
      isMax: false,
      message: "Adicione produtos para começar a ganhar desconto",
      states: [],
      ranges: [],
    };
  }

  const last = faixas[n - 1];
  const lastQty = last.qty;
  const ranges = montarRanges(faixas, porRange, limitarRegua);
  let currentIndex = -1;
  for (let i = 0; i < n; i += 1) {
    if (total >= ranges[i].start) currentIndex = i;
  }

  const states = ranges.map((range, i) => {
    if (total >= range.start) return "done";
    if (i === currentIndex + 1) return "current";
    return "pending";
  });

  const fillByQty = lastQty > 0 ? Math.min(100, (total / lastQty) * 100) : 0;

  if (total === 0) {
    const first = ranges[0];
    return {
      fill: 0,
      currentPct: 0,
      isMax: false,
      nextPct: first.pct,
      missing: first.start,
      message: `Adicione ${first.start} ${labelItens(first.start)} para ganhar ${first.pct}% de desconto`,
      states: faixas.map(() => "pending"),
      ranges,
    };
  }

  if (currentIndex === n - 1) {
    return {
      fill: 100,
      currentPct: last.pct,
      isMax: true,
      message: limitarRegua
        ? `Você chegou no desconto máximo. O limite desta promoção é ${lastQty} ${labelItens(lastQty)}.`
        : "Você chegou no desconto máximo. Adicione mais produtos para aproveitar.",
      states,
      ranges,
    };
  }

  const next = ranges[currentIndex + 1];
  const missing = Math.max(0, next.start - total);
  const currentPct = currentIndex >= 0 ? ranges[currentIndex].pct : 0;
  const message =
    currentPct > 0
      ? `${fraseFaltam(missing)} para alcançar ${next.pct}% de desconto`
      : `${fraseFaltam(missing)} para ganhar ${next.pct}% de desconto`;

  return {
    fill: fillByQty,
    currentPct,
    isMax: false,
    nextPct: next.pct,
    missing,
    message,
    states,
    ranges,
  };
}

function posBolinha(range, lastQty) {
  const marca = range.start || range.qty || 1;
  return lastQty > 0 ? (marca / lastQty) * 100 : 0;
}

function renderTrilha(trilhaEl, fillEl, faixas, progresso, limitarRegua) {
  if (!trilhaEl || !fillEl) return;
  fillEl.style.display = "block";
  fillEl.style.width = `${progresso.fill}%`;
  trilhaEl.querySelectorAll(".pd-minicart__bolinha").forEach((node) => node.remove());
  const lastQty = faixas[faixas.length - 1]?.qty || 1;
  const ranges = progresso.ranges && progresso.ranges.length ? progresso.ranges : faixas.map((f) => ({ start: f.qty, qty: f.qty, pct: f.pct }));

  ranges.forEach((range, i) => {
    const isLast = i === ranges.length - 1;
    const node = document.createElement("div");
    node.className = `pd-minicart__bolinha is-${progresso.states[i] || "pending"}`;
    node.style.left = `${posBolinha(range, lastQty)}%`;
    const plus = isLast && !limitarRegua ? "+" : "";
    node.innerHTML = `
      <span class="pd-minicart__bolinha-dot">${progresso.states[i] === "done" ? "✓" : ""}</span>
      <span class="pd-minicart__bolinha-label">${range.pct}%${plus}</span>
    `;
    trilhaEl.appendChild(node);
  });
}

const PdCart = {
  faixas: FAIXAS_PADRAO,
  limitarRegua: false,
  porRange: false,
  cupom: "",
  limites: { descontoMaximo: 0, tetoCarrinho: 0 },
  cart: { item_count: 0, items: [], total_price: 0 },

  async init() {
    const config = lerConfig();
    this.faixas = config.faixas;
    this.limitarRegua = config.limitarRegua;
    this.porRange = config.porRange;
    this.cupom = config.cupom;
    this.limites = config.limites;
    this.bind();
    await this.sync();
  },

  root() {
    return window.Shopify?.routes?.root || "/";
  },

  qtyMaxima() {
    return Number(this.faixas[this.faixas.length - 1]?.qty) || 0;
  },

  vagasRestantes() {
    if (!this.limitarRegua) return Infinity;
    const max = this.qtyMaxima();
    if (!max) return Infinity;
    return Math.max(0, max - (this.cart.item_count || 0));
  },

  quantidadePermitida(desejada) {
    const qtd = Number(desejada) || 0;
    if (qtd <= 0) return 0;
    if (!this.limitarRegua) return qtd;
    return Math.min(qtd, this.vagasRestantes());
  },

  msgLimite() {
    const max = this.qtyMaxima();
    return `O limite desta promoção é ${max} ${labelItens(max)}.`;
  },

  atualizarTravas() {
    const travado = this.limitarRegua && this.vagasRestantes() <= 0;
    document.querySelectorAll(".pd-produto-card__adicionar").forEach((btn) => {
      btn.disabled = travado;
      btn.classList.toggle("is-locked", travado);
      if (travado) btn.setAttribute("title", this.msgLimite());
      else btn.removeAttribute("title");
    });
    document.querySelectorAll(".pd-carrinho-item__qtd-btn[data-action='aumentar']").forEach((btn) => {
      btn.disabled = travado;
      btn.classList.toggle("is-locked", travado);
    });
    document.body.classList.toggle("pd-limite-atingido", travado);
  },

  montarUrlCheckout() {
    const items = this.cart.items || [];
    if (!items.length) return "";
    const parametros = items
      .filter((item) => Number(item.quantity) > 0)
      .map((item) => `${item.variant_id || item.id}:${item.quantity}`)
      .join(",");
    if (!parametros) return "";
    const base = `${this.root()}cart/${parametros}`;
    if (!this.cupom) return base;
    return `${base}?discount=${encodeURIComponent(this.cupom)}`;
  },

  async irParaCheckout(event) {
    event.preventDefault();
    const url = this.montarUrlCheckout();
    if (!url) return;
    try {
      await fetch(`${this.root()}cart/clear.js`, { method: "POST" });
    } catch (e) {
      /* permalink recria o carrinho com os ids */
    }
    window.location.href = url;
  },

  async sync() {
    try {
      const res = await fetch(`${this.root()}cart.js`);
      if (!res.ok) throw new Error("cart.js");
      this.cart = await res.json();
    } catch (e) {
      this.cart = this.cart || { item_count: 0, items: [], total_price: 0 };
    }
    this.render();
  },

  async add(id, quantity) {
    const permitido = this.quantidadePermitida(quantity);
    if (permitido <= 0) {
      throw new Error(this.msgLimite());
    }
    const res = await fetch(`${this.root()}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: permitido }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || "Não foi possível adicionar");
    }
    await this.sync();
  },

  async change(line, quantity) {
    const atual = Number(this.cart.items?.[line - 1]?.quantity || 0);
    const next = Number(quantity);
    if (next > atual && this.quantidadePermitida(next - atual) <= 0) {
      this.toast(this.msgLimite());
      return;
    }
    const res = await fetch(`${this.root()}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity: Number(quantity) }),
    });
    if (!res.ok) throw new Error("change.js");
    this.cart = await res.json();
    this.render();
  },

  render() {
    const count = this.cart.item_count || 0;
    const progresso = calcularProgresso(count, this.faixas, this.limitarRegua, this.porRange);
    const totais = totaisPedido(this.cart, progresso.currentPct, this.limites);
    const itemLabel = count === 1 ? "item" : "itens";
    const maxPct = this.faixas[this.faixas.length - 1]?.pct || 40;

    const contador = document.getElementById("pd-header-contador");
    if (contador) {
      contador.textContent = String(count);
      contador.classList.toggle("show", count > 0);
    }

    const economia = document.getElementById("pd-minicart-economia");
    const economiaSub = document.getElementById("pd-minicart-economia-sub");
    if (economia) {
      if (progresso.currentPct > 0) {
        economia.textContent = `Você ganhou ${progresso.currentPct}% de desconto`;
        if (economiaSub) {
          if (totais.limitado) {
            economiaSub.textContent = `Economia limitada a ${formatarDinheiro(totais.desconto)}`;
          } else if (progresso.isMax) {
            economiaSub.textContent = "Você chegou no desconto máximo";
          } else {
            economiaSub.textContent = `Economia de ${formatarDinheiro(totais.desconto)}`;
          }
        }
      } else {
        economia.textContent = `Ganhe até ${maxPct}% de desconto`;
        if (economiaSub) economiaSub.textContent = "adicione mais produtos";
      }
    }

    const msgMini = document.getElementById("pd-minicart-msg");
    const msgCart = document.getElementById("pd-carrinho-msg");
    [msgMini, msgCart].forEach((msg) => {
      if (!msg) return;
      msg.textContent = progresso.message;
      msg.classList.toggle("is-max", Boolean(progresso.isMax));
    });

    renderTrilha(
      document.getElementById("pd-minicart-trilha"),
      document.getElementById("pd-minicart-fill"),
      this.faixas,
      progresso,
      this.limitarRegua
    );
    renderTrilha(
      document.getElementById("pd-carrinho-trilha"),
      document.getElementById("pd-carrinho-fill"),
      this.faixas,
      progresso,
      this.limitarRegua
    );

    const totalMini = document.getElementById("pd-minicart-total");
    if (totalMini) {
      totalMini.innerHTML = `${htmlPreco(totais.bruto, totais.atual)} / ${count} ${itemLabel}`;
    }

    const totalCart = document.getElementById("pd-carrinho-total");
    const itensCart = document.getElementById("pd-carrinho-itens");
    const descontoCart = document.getElementById("pd-carrinho-desconto");
    if (totalCart) totalCart.innerHTML = htmlPreco(totais.bruto, totais.atual);
    if (itensCart) itensCart.textContent = String(count);
    if (descontoCart) {
      if (progresso.currentPct > 0) {
        descontoCart.hidden = false;
        descontoCart.textContent = totais.limitado
          ? `Você ganhou ${progresso.currentPct}% de desconto (limitado a ${formatarDinheiro(totais.desconto)})`
          : `Você ganhou ${progresso.currentPct}% de desconto`;
      } else {
        descontoCart.hidden = true;
        descontoCart.textContent = "";
      }
    }

    const checkout = document.getElementById("pd-carrinho-checkout");
    if (checkout) {
      const url = this.montarUrlCheckout();
      checkout.href = url || `${this.root()}cart`;
      checkout.classList.toggle("is-disabled", count === 0);
      checkout.setAttribute("aria-disabled", count === 0 ? "true" : "false");
    }

    this.renderItens(totais, progresso.currentPct);
    this.atualizarTravas();
    if (count > 0) this.showMinicart();
    else this.hideMinicart();
  },

  renderItens(totais, pct) {
    const container = document.getElementById("pd-carrinho-produtos");
    if (!container) return;
    const items = this.cart.items || [];
    if (!items.length) {
      container.innerHTML = '<p class="pd-carrinho__vazio">Seu carrinho está vazio.</p>';
      return;
    }
    container.innerHTML = items
      .map((item, index) => {
        const valores = totaisItem(item, totais, pct);
        return `
      <div class="pd-carrinho-item" data-line="${index + 1}">
        <img src="${item.image || ""}" alt="${item.product_title || ""}" class="pd-carrinho-item__imagem">
        <div class="pd-carrinho-item__coluna">
          <div class="pd-carrinho-item__nome">${item.product_title || ""}</div>
          <div class="pd-carrinho-item__preco">${htmlPreco(valores.bruto, valores.atual)}</div>
        </div>
        <div class="pd-carrinho-item__quantidade">
          <button class="pd-carrinho-item__qtd-btn" data-action="diminuir" type="button" aria-label="Diminuir">-</button>
          <span class="pd-carrinho-item__qtd-valor">${item.quantity}</span>
          <button class="pd-carrinho-item__qtd-btn" data-action="aumentar" type="button" aria-label="Aumentar" ${
            this.limitarRegua && this.vagasRestantes() <= 0 ? "disabled" : ""
          }>+</button>
        </div>
      </div>`;
      })
      .join("");
  },

  showMinicart() {
    const el = document.getElementById("pd-minicart");
    if (el) el.hidden = false;
  },

  hideMinicart() {
    const el = document.getElementById("pd-minicart");
    if (el) el.hidden = true;
  },

  openCart() {
    document.getElementById("pd-carrinho")?.classList.add("show");
    document.body.style.overflow = "hidden";
  },

  closeCart() {
    document.getElementById("pd-carrinho")?.classList.remove("show");
    document.body.style.overflow = "";
  },

  openModal(card) {
    const modal = document.getElementById("pd-modal");
    if (!modal) return;
    const img = card.querySelector(".pd-produto-card__imagem");
    const titulo = card.querySelector(".pd-produto-card__nome");
    const modalImg = document.getElementById("pd-modal-imagem");
    const modalTitulo = document.getElementById("pd-modal-titulo");
    if (modalImg && img) {
      modalImg.src = img.src;
      modalImg.alt = img.alt || "";
    }
    if (modalTitulo && titulo) modalTitulo.textContent = titulo.textContent;
    const desc = document.getElementById("pd-modal-descricao");
    if (desc) desc.innerHTML = `<p>${card.getAttribute("data-descricao-curta") || ""}</p>`;
    const set = (id, attr) => {
      const el = document.getElementById(id);
      if (el) el.textContent = card.getAttribute(attr) || "-";
    };
    set("pd-modal-regiao", "data-regiao");
    set("pd-modal-notas", "data-notas-sensoriais");
    set("pd-modal-torra", "data-torra");
    set("pd-modal-variedade", "data-variedade");
    modal.classList.add("show");
    document.body.style.overflow = "hidden";
  },

  closeModal() {
    document.getElementById("pd-modal")?.classList.remove("show");
    document.body.style.overflow = "";
  },

  toast(mensagem) {
    const toast = document.getElementById("pd-toast");
    if (!toast) return;
    const msg = toast.querySelector(".pd-toast__message");
    if (msg) msg.textContent = mensagem;
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 3000);
  },

  bind() {
    document.querySelectorAll(".pd-tab-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const tab = btn.getAttribute("data-tab");
        document.querySelectorAll(".pd-tab-btn").forEach((b) => {
          b.classList.remove("active");
          b.setAttribute("aria-selected", "false");
        });
        document.querySelectorAll(".pd-tab-pane").forEach((p) => p.classList.remove("active"));
        btn.classList.add("active");
        btn.setAttribute("aria-selected", "true");
        document.getElementById(`tab-${tab}`)?.classList.add("active");
      });
    });

    document.querySelectorAll(".pd-produto-card__qtd-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const wrap = btn.closest(".pd-produto-card__quantidade, .pd-destaque__acoes");
        const valorEl = wrap?.querySelector(".pd-produto-card__qtd-valor");
        let valor = parseInt(valorEl?.textContent || "1", 10);
        if (btn.textContent.trim() === "+") {
          const vagas = this.vagasRestantes();
          if (this.limitarRegua && valor >= vagas) {
            this.toast(this.msgLimite());
            return;
          }
          valor += 1;
        } else {
          valor = Math.max(1, valor - 1);
        }
        if (valorEl) valorEl.textContent = String(valor);
      });
    });

    document.querySelectorAll(".pd-produto-card__adicionar").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const card = btn.closest(".pd-produto-card");
        if (!card) return;
        const id = card.getAttribute("data-id");
        const nome = card.querySelector(".pd-produto-card__nome")?.textContent?.trim() || "Produto";
        const qtd = parseInt(card.querySelector(".pd-produto-card__qtd-valor")?.textContent || "1", 10);
        if (this.quantidadePermitida(qtd) <= 0) {
          this.toast(this.msgLimite());
          return;
        }
        const original = btn.textContent;
        btn.disabled = true;
        try {
          await this.add(id, qtd);
          btn.textContent = "Adicionado ✓";
          this.toast(`"${nome}" adicionado!`);
        } catch (e) {
          this.toast(e.message || "Não foi possível adicionar");
        } finally {
          setTimeout(() => {
            btn.textContent = original;
            this.atualizarTravas();
          }, 1500);
        }
      });
    });

    document.querySelectorAll(".pd-produto-card").forEach((card) => {
      [".pd-produto-card__imagem-container", ".pd-produto-card__nome", ".pd-produto-card__lupa", ".pd-destaque__imagem"].forEach(
        (sel) => {
          const el = card.querySelector(sel);
          if (!el) return;
          el.addEventListener("click", (e) => {
            if (!e.target.closest("button")) this.openModal(card);
          });
        }
      );
    });

    document.getElementById("pd-header-carrinho")?.addEventListener("click", () => this.openCart());
    document.getElementById("pd-minicart-ver")?.addEventListener("click", () => this.openCart());
    document.querySelector(".pd-minicart__fechar")?.addEventListener("click", () => this.hideMinicart());
    document.getElementById("pd-carrinho-fechar")?.addEventListener("click", () => this.closeCart());
    document.querySelector(".pd-carrinho__overlay")?.addEventListener("click", () => this.closeCart());
    document.getElementById("pd-modal-fechar")?.addEventListener("click", () => this.closeModal());
    document.querySelector(".pd-modal__overlay")?.addEventListener("click", () => this.closeModal());
    document.getElementById("pd-carrinho-checkout")?.addEventListener("click", (e) => this.irParaCheckout(e));

    document.getElementById("pd-carrinho-produtos")?.addEventListener("click", async (e) => {
      const btn = e.target.closest(".pd-carrinho-item__qtd-btn");
      if (!btn) return;
      const item = btn.closest(".pd-carrinho-item");
      const line = Number(item?.getAttribute("data-line"));
      const atual = parseInt(item?.querySelector(".pd-carrinho-item__qtd-valor")?.textContent || "1", 10);
      const next = btn.dataset.action === "aumentar" ? atual + 1 : atual - 1;
      try {
        await this.change(line, Math.max(0, next));
      } catch (err) {
        this.toast("Não foi possível atualizar o carrinho");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.closeModal();
        this.closeCart();
      }
    });
  },
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => PdCart.init());
} else {
  PdCart.init();
}
